export const PSIM_HEADER_COLORS = {
  paintBlock: 'FFFCE4D6',
  psimCof: 'FFE5D1E8',
  section: 'FFFCE4D6',
  ri: 'FFD9E8F5',
  severity: 'FFD9D2E9',
  total: 'FFDDEED0',
};

export const CM_HEADER_COLORS = {
  paintBlock: 'FFFCE4D6',
  uncalibratedSection: 'FFE7E6E6',
  calibratedSection: 'FFD9D2E9',
  remediationSection: 'FFD9D2E9',
  ri: 'FFD9E8F5',
  total: 'FFDDEED0',
};

export const COMBINED_HEADER_COLORS = {
  paintBlock: 'FFFCE4D6',
  psimCof: 'FFE5D1E8',
  psimBlockArea: 'FFFFE599',
  psimSection: 'FFFCE4D6',
  cmUncalibratedSection: 'FFE7E6E6',
  cmCalibratedSection: 'FFD9D9D9',
  cmRemediationSection: 'FFD9D2E9',
  remediationArea: 'FFE6B8AF',
  ri: 'FFD9E8F5',
  severity: 'FFD9D2E9',
  total: 'FFDDEED0',
};
